<template>
    <div class="rule-module">
        <span class="logo"
              v-if="config.logoStatus"></span>
        <span class="rule-btn"
              @click.stop="show">规则</span>
    
        <transition name="slider-l">
            <div class="rule-wrap"
                 v-if="status">
                <i class="close-icon"
                   @click.stop="hide"></i>
                <h3 class="tit">活动规则</h3>
                <ol class="rule-list">
                    <li v-for="item in config.rules">{{item}}</li>
                </ol>
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
@import '../../../less/base/util.less';
.rule-module {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 11;
    width: 100%;
    .logo {
        float: left;
        .size(1.16rem, .16rem);
        /*background: url('../img/logo.png') no-repeat;*/
        background-size: contain;
        margin: .12rem 0 0 .1rem;
    }
    .rule-btn {
        float: right;
        background: rgba(226, 85, 122, 1);
        color: #fff;
        .clearfix;
        font-size: .12rem;
        padding: .03rem .07rem;
        .radius(.09rem);
        margin: .11rem .12rem 0 0;
    }
}

.rule-wrap {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 11;
    .size(100%, 100%);
    background: rgba(0, 0, 0, .8);
    color: #fff;
    .close-icon {
        float: right;
        .size(.6rem, .6rem);
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAMAAABEH1h2AAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMAFdMDCtQP+frJOVqI8GIo4vTcVs6BZd7CvLKhTUhDNJMjxZqHe+SV1aMhHas9QCtVAAACT0lEQVRIx5TR6Y6DIBiF4VOhIIpb99a2doldpjn3f3sz6UxMyAjV95chPPIF4Ent29qUFVndTN3uFUZ0XpqYTrFZnodZkV5I6o3Nk5cC1CvJ7UaTvKTiM85nZFUfJJzk4ZqRs1yEdbIgHyuJnuTqQS6SAJYnsvSPKOYleZLwVETUViKQtJpRgd6OGdcNPtSsmR3R01xzp/AxtaOe9+iYV4EBiSvjf/6oaTEwS32EU5HxjsHdmTn3JyPuxHAudoyk87u1wojUmid0JYwbjKqJmXSzRLQYmeVC4LecpRzLZckc78SMKUaXcibcj7+K7QQ9TbbdYzmHGq6cfVtGkx4dcessrGjeh7GS7sZp5x09dRdlxQLAkjXg8QEN1Fy+Zz/A44MaBxpAxVrC44MaUscKe24Ajw9qYMM9Wlr4fFjDssWTKbw+qJHyCcMEfh/SSGhw4ws+/wMDGl+8IaNCwAc0JqxAAgEf0BBkmEf8rr2MWhiEYSDsWrUvTmWr7m2oVBhi/v/fG6xgKUeDXTCPxQ8kbS53pDjcsD+vqFIMf6M71zrlW6fSrXsxF+fBiIeLi58N0jGPz2alhqFZvqEVRgYR5MPIwMAigHwY2CAXQMMByoUXqxSNRyhWs5dK+BR5kMqf1Vv+FepFuCbES0q+IgttyeXijqyW2wNfU645edBUhCo/udbIliJjNoMtdOfbZt4yUyqzxHJDjtVVZBwfB5yhqmPDyDMjjOREoVZBFILSY58OYv14JskdMXCrta63Iwa2+qoQihF42K2PwHYfkhH4C/7ERPKlJw9WAAAAAElFTkSuQmCC) center center no-repeat;
        background-size: .31rem;
        margin: .2rem 0 0;
    }
    .tit {
        text-align: center;
        border-bottom: 1px solid #fff;
        padding: .9rem 0 .1rem;
        margin: 0 .15rem;
        font-size: .20rem;
        font-weight: normal;
    }
    .rule-list {
        padding: 0 .1rem .2rem .3rem;
        .box-sizing(border-box);
        margin: 0 auto;
        list-style-position: outside;
        list-style-type: decimal;
        text-align: left;
        height: 4rem;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        li {
            line-height: .2rem;
            padding-top: .15rem;
        }
    }
}
</style>

<script>
import UR from '@dp/url-rewrite';
import { data } from '../api/url';
let GetQueryString = require('@lib/getQueryString');
let isTuneup = GetQueryString('lch') || GetQueryString('utm_source') || GetQueryString('source') || "";
let oneTurnup = GetQueryString('isTuneup') || "";
// ajax
// import {
//     url,
//     data
// } from '../api/url';
export default {
    data() {
        return {
            rules: ['1111', '222'],
            status: false
        }
    },
    props: ['config'],
    methods: {
        hide() {
            this.status = false;
        },
        lingxiClick (indexs,clickName){
               Analytics('event', {
                    nm:'mge',
                    val_bid: clickName,
                    event_type: 'click', // 可选参数
                    val_lab: { // 默认没有
                        custom: {// val_val 满足不了的信息
                            index: indexs// 这里设置自定义埋点信息
                        }
                    }
                }); 
        },
        show() {
            this.lingxiClick(0,'b_cvngprg3');
            if (isTuneup != "" && !window.Env.isApp && oneTurnup == "") {
                var urllink = 'https://' + location.host + '/app/app-wedding-peons/act/march_promotion/index_page.html?utm_source=wxpush&isTuneup=yes'
                location.href = UR.web({ 'url': urllink });
            }
            this.status = true;
        }
    }
}

</script>


// WEBPACK FOOTER //
// rule.vue?2a288948